export default __webpack_public_path__ + "static/media/university.8755146a.svg";